import { connect } from 'react-redux'
import InboundProgram from '../components/InboundProgram'
import * as inboundProgramActions from '../actions/inboundProgram'

const mapStateToProps = (state, ownProps) => {   
	return {
		...state.inboundNumbers, 
		inboundProgramAccountTypes: state.homePage.inboundProgramAccountTypes,
		assetValidationTypes: state.homePage.assetValidationTypes,
		vehicleTypes: state.homePage.vehicleTypes
	}
}

const mapDispatchToProps = (dispatch, ownProps) => ({ 
	fetchNumbers: () => dispatch(inboundProgramActions.fetchNumbers()), 
	saveNewInbound: (inboundProgram) => dispatch(inboundProgramActions.saveNewInbound(inboundProgram)),
	newOnChange: (event) => dispatch(inboundProgramActions.newOnChange(event)),
	newSelectOnChange: (event) => dispatch(inboundProgramActions.newSelectOnChange(event)),
	addInbound: () => dispatch(inboundProgramActions.openNewInbound()), 
	closeMe: () => dispatch(inboundProgramActions.closeMe()),
	editCloseMe: () => dispatch(inboundProgramActions.editCloseMe()),
	startingInboundSave: () => dispatch(inboundProgramActions.startingInboundSave()),
	closeEditInbound: () => dispatch(inboundProgramActions.closeEditInbound()),
	openEditInbound: (obj) => dispatch(inboundProgramActions.openEditInbound(obj)),
	saveInboundEdit: () => dispatch(inboundProgramActions.saveInboundEdit()),
	editOnChange: (event) => dispatch(inboundProgramActions.editOnChange(event)),
	editSelectOnChange: (event) => dispatch(inboundProgramActions.editSelectOnChange(event)),
	newOnChangeCustomerName: (event) => dispatch(inboundProgramActions.newOnChangeCustomerName(event)), 
	startShipToSearch: ()=> dispatch(inboundProgramActions.startShipToSearch()),
	shipToSearchChange: (event) => dispatch(inboundProgramActions.shipToSearchChange(event)),
	loadShipTo: (shipTo) => dispatch(inboundProgramActions.loadShipTo(shipTo)),
	loadCustomer: (customerName, billTo, accountTypeId) => dispatch(inboundProgramActions.loadCustomer(customerName, billTo, accountTypeId)), 
})

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(InboundProgram)



// WEBPACK FOOTER //
// ./src/containers/InboundProgramContainer.js